














































































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import AppDialog from '@/components/AppDialog.vue'
import pdf from 'vue-pdf'
import { TextTask, PresumedForm, PresumedTable } from '@/modules/OCR/interfaces/textTract-task'
import { getAmount } from '@/utils/ocr-amount'
@Component({
  components: {
    AppDialog,
    pdf
  }
})
// vue.runtime.esm.js:619 [Vue warn]: Duplicate keys detected: '(70.00)'. This may cause an update error.
export default class OcrDetailDialog extends Vue {
  @Prop(Boolean) value!: boolean;
  @Prop({ type: [Number, String], default: 1300 }) readonly width!: number | string;
  @Prop({ type: [Number], default: 750 }) readonly height!: number;
  @Prop({ type: [String, Object], default: 'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf' }) readonly url!: string | object;
  @Prop({ type: [Object], default: {} }) readonly textractTasksDetail!: object;
  @Prop({ type: [String], default: 'pdf' }) readonly fileType!: string;

  model = false
  currentItem: TextTask | null = null

  currentPage = 1
  totalPages = 0
  showFormData = true
  showFormTableData = false
  getAmount = getAmount
  formData: PresumedForm[] = []
  tableData:PresumedTable[] = [
    {
      header: [
        [],
        []
      ],
      body: [
        []
      ],
      rowNum: 0,
      columnNum: 0
    }
  ]

  data = []

  windowSize = {
    w: 0,
    h: 0
  };

  get dialogHeight () {
    const {
      height,
      windowSize: { h }
    } = this

    return height > h - 50 ? h - 50 : height
  }

  mounted () {
    this.model = this.value
  }

  @Emit('input')
  closeDialog () {
    return false
  }

  @Emit('confirm')
  confirmDialog () {}

  @Emit('cancel')
  cancelDialog () {
    this.closeDialog()
  }

  @Watch('value')
  valueChanged (val: boolean) {
    this.model = val
  }
  @Watch('textractTasksDetail')
  textractTasksDetailChanged (val: TextTask) {
    this.currentItem = val
    if (val.recognizedContent.form && (val.type === 'POLICY' || val.type === 'DRIVER_LICENSE')) {
      this.formData = val.recognizedContent.form
      this.showFormData = true
    } else if (val.recognizedContent.table && (val.type === 'PROGRESSIVE_COMMISSION' || val.type === 'COUNTRY_WIDE_COMMISSION')) {
      this.tableData = val.recognizedContent.table
      this.showFormData = false
    } else if (val.recognizedContent.table || val.recognizedContent.form) {
      if (val.recognizedContent.form) {
        this.formData = val.recognizedContent.form
      }
      if (val.recognizedContent.table) {
        this.tableData = val.recognizedContent.table
      }
      this.showFormTableData = true
    }
  }

  keyDownHandler (e: KeyboardEvent) {
    if (e.key === 'Enter' && e.ctrlKey) {
      this.confirmDialog()
    }
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
  }

  goToPage (pageNumber: number) {
    if (pageNumber >= 1 && pageNumber <= this.totalPages) {
      this.currentPage = pageNumber
    }
  }
}
